import { IModel, Model } from '.';

export interface IHospitalSalesItemFavoritesModel extends IModel {
  hospitalSalesItemFavoriteId: number;
  hospitalId: number;
  salesItemOptionId: number;
}

export class HospitalSalesItemFavoritesModel
  extends Model
  implements IHospitalSalesItemFavoritesModel
{
  hospitalSalesItemFavoriteId: number;
  hospitalId: number;
  salesItemOptionId: number;

  constructor(params?: Partial<IHospitalSalesItemFavoritesModel>) {
    super(params);

    this.hospitalSalesItemFavoriteId = _.defaultTo(
      params?.hospitalSalesItemFavoriteId,
      0,
    );

    this.hospitalId = _.defaultTo(params?.hospitalId, 0);
    this.salesItemOptionId = _.defaultTo(params?.salesItemOptionId, 0);
  }
}
